import { useHistory } from "react-router-dom";

const PAGE_PARAM = "page";

/**
 * Returns a navigate callback that updates the `?page=` query param while
 * preserving every other search param. Used as the default `navigate`
 * for Pagination when the consumer doesn't pass one explicitly.
 *
 * Mirrors v1 neeto-ui Pagination's auto URL sync behavior. Must be
 * rendered inside a react-router-dom v5 history context.
 */
export const usePaginationQueryParams = () => {
  const history = useHistory();

  const updatePageInQueryParam = (page: number) => {
    const params = new URLSearchParams(window.location.search);
    params.set(PAGE_PARAM, String(page));
    history.push(`${window.location.pathname}?${params.toString()}`);
  };

  return { updatePageInQueryParam };
};
